export default {
  STATUS_ORDER_PENDING: 100,
  STATUS_ORDER_CREATED: 101,
  STATUS_ORDER_IN_RECEPTION: 102,
  STATUS_ORDER_ON_HOLD: 103,
  STATUS_ORDER_NOT_STARTED: 104,
  STATUS_ORDER_MECHANICAL_REVIEW: 105,
  STATUS_ORDER_STOPPED: 106,
  STATUS_ORDER_CUSTOMER_REVIEW: 107,
  STATUS_ORDER_IN_PROCESS: 108,
  STATUS_ORDER_COMPLETED: 109,
  STATUS_ORDER_QUALITY_CONTROL: 110,
  STATUS_ORDER_BUDGET: 111,
  STATUS_ORDER_PAID_OUT: 112,
  STATUS_ORDER_CLOSED: 'CERRADA',
  STATUS_ORDER_OPEN: 'ABIERTA',
  MODULE_ADDITIONAL_BUDGETS: 'MODULE_ADDITIONAL_BUDGETS',
  MODULE_PAYMENT: 'PAYMENT',
  MODULE_RECEPTION: 'MODULE_RECEPTION',
  MODULE_INVOICES: 'MODULE_INVOICES',
  MODULE_ACTIVITIES: 'MODULE_ACTIVITIES',
  SHOW_PRICE_VISIBLE: 0,
  SHOW_PRICE_HIDDEN: 1,
  BUDGET_STATUS: {
    BUDGET_EMPTY: 100,
    BUDGET_INCOMPLETE: 101,
    BUDGET_TO_VALIDATE: 102,
    BUDGET_ACCEPTED: 103,
    BUDGET_PARTIALLY_ACCEPTED: 104,
    BUDGET_REJECTED: 105,
    BUDGETED: 106,
    ORDER_BY_BUDGET: 107,
    STATUS_ORDER_AWAITING_QUOTE: 140,
    STATUS_ORDER_QUOTE_READY_SHIPPING: 141,
  },
};
